import React from "react";
import { UserRoutes } from "./routes/userRoutes";
import "./styles/scss/app.scss";

const App: React.FC = () => {
  return <UserRoutes />;
};

export default App;
